<!-- 整块大屏 1920*1080 -->
<template>
<div style="position: relative;width: 1920px;height: 1080px;overflow: auto;" id="allDisplay" @click="handleFullScreen">
  <div class="allDisplay">
    <!-- 大屏标题 -->
    <div class="hand-font">
      <img style="height: 46px; margin: 0px 33px 0 34px"  src="../../../../static/img/display-img/show_new/text_tit.png">
      <span style="fontSize: 24px; lingHeight: 28px; color: #97ccf4">/ Intelligent platform of Human settlement Environment in Sanhe City</span>
    </div>
    <img class="hand-line" src="../../../../static/img/display-img/hand-line.png">
    <!-- 处理站状态图标 -->
    <img class="zhuangtai-1" src="../../../../static/img/display-img/chulizhanzhuangtai-bk.png">
    <div class="zhuangtai-1-logo">
      <img class="logo" src="../../../../static/img/display-img/chulizhan-1.png">
      <span>处理站1</span>
      <span>运行中</span>
    </div>
    <img class="zhuangtai-2" src="../../../../static/img/display-img/chulizhanzhuangtai-bk.png">
    <div class="zhuangtai-2-logo">
      <img class="logo" src="../../../../static/img/display-img/chulizhan-2.png">
      <span>处理站2</span>
      <span>运行中</span>
    </div>
    <img class="zhuangtai-3" src="../../../../static/img/display-img/chulizhanzhuangtai-bk.png">
    <div class="zhuangtai-3-logo">
      <img class="logo" src="../../../../static/img/display-img/chulizhan-3.png">
      <span>处理站3</span>
      <span>运行中</span>
    </div>
    <img class="zhuangtai-4" src="../../../../static/img/display-img/chulizhanzhuangtai-bk.png">
    <div class="zhuangtai-4-logo">
      <img class="logo" src="../../../../static/img/display-img/chulizhan-4.png">
      <span>处理站4</span>
      <span>运行中</span>
    </div>

    <div class="data-layer-left">
      <!-- 地图左边 数据层 -->
      <DYL></DYL>
    </div>
    <div class="data-layer-right">
      <!-- 地图右边 数据层 -->
      <DYR></DYR>
    </div>
    <div class="center">
      <!-- <span class="font">中:地图</span> -->
      <CDis></CDis>
    </div>
    <div class="buttom">
      <!-- <span class="font">视频</span> -->
      <BDis></BDis>
    </div>
  </div>
</div>
</template>
<script>
import DYL from './leftDataDisplay.vue';
import DYR from './rightDataDisplay.vue';
import CDis from './topCenterDisplay.vue';
import BDis from './buttomDisplay.vue';

export default {
  components: {
      DYL,DYR,CDis,BDis
  },
  name: "allDisplay",
  data() {
    return {
      fullscreen: false,
    };
  },
  created() {

  },
  mounted(){
  },

  computed: {},
  watch: {},
  methods: {

    handleFullScreen() {
      // console.log(this.fullscreen)
      let element = document.getElementById('allDisplay');
      if (this.fullscreen) {
          // if (document.exitFullscreen) {
          //     document.exitFullscreen();
          // } else if (document.webkitCancelFullScreen) {
          //     document.webkitCancelFullScreen();
          // } else if (document.mozCancelFullScreen) {
          //     document.mozCancelFullScreen();
          // } else if (document.msExitFullscreen) {
          //     document.msExitFullscreen();
          // }
      } else {
          if (element.requestFullscreen) {
              element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
              // IE11
              element.msRequestFullscreen();
          }
      }
      this.fullscreen = !this.fullscreen;
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang='scss' scoped>
.allDisplay {
  display: flex;
  position: absolute;
  width: 1920px;
  height: 1080px;
}
.data-layer-left {
  position: absolute;
  width: 440px;
  height: 1078px;
  z-index: 10;
  background-color: rgba($color: #002572, $alpha: 0.9);
  // background:linear-gradient(to right,#002571,#012573d6,#01257300) //渐变
}
.data-layer-right {
  margin-left: 1478px;
  position: absolute;
  width: 440px;
  height: 1078px;
  z-index: 10;
  background-color: rgba($color: #002572, $alpha: 0.9);
  // background:linear-gradient(to left,#002571,#012573d6,#01257300) //渐变
}
.center {
  position: absolute;
  width: 1920px;
  height: 1080px;
}
.buttom {
  position: absolute;
  width: 950px;
  height: 250px;
  left: 50%;
  margin-left: -475px;
  margin-top: 820px;
}
.hand-font {
  display: flex;
  justify-content: left;
  align-items: center;
  position: absolute;
  z-index: 100;
  margin: 0px 0px 0px 16px;
  width: 1575px;
  height: 69px;
  text-align: left;
}
.hand-line {
  position: absolute;
  z-index: 100;
  margin: 68px 0px 0px 0px;
  width: 1590px;
  height: 12px;
}
.zhuangtai-1 {
  position: absolute;
  z-index: 100;
  margin: 120px 0px 0px 591px;
  width: 170px;
  height: 46px;
}
.zhuangtai-2 {
  position: absolute;
  z-index: 100;
  margin: 120px 0px 0px 780px;
  width: 170px;
  height: 46px;
}
.zhuangtai-3 {
  position: absolute;
  z-index: 100;
  margin: 120px 0px 0px 970px;
  width: 170px;
  height: 46px;
}
.zhuangtai-4 {
  position: absolute;
  z-index: 100;
  margin: 120px 0px 0px 1158px;
  width: 170px;
  height: 46px;
}
.zhuangtai-1-logo {
  position: absolute;
  z-index: 110;
  margin: 134px 0px 0px 605px;
  width: 150px;
  height: 19px;
  span {
    position: relative;
    bottom: 3px;
    width: 54px;
    height: 15px;
    font-size: 16px;
   
    font-weight: 550;
    color: #00FFEA;
    line-height: 24px;
  }
}
.zhuangtai-2-logo {
  position: absolute;
  z-index: 100;
  margin: 134px 0px 0px 794px;
  width: 150px;
  height: 19px;
  span {
    position: relative;
    bottom: 3px;
    width: 54px;
    height: 15px;
    font-size: 16px;
   
    font-weight: 550;
    color: #FFA200;
    line-height: 24px;
  }
}
.zhuangtai-3-logo {
  position: absolute;
  z-index: 100;
  margin: 134px 0px 0px 984px;
  width: 150px;
  height: 19px;
  span {
    position: relative;
    bottom: 3px;
    width: 54px;
    height: 15px;
    font-size: 16px;
   
    font-weight: 550;
    color: #FF477C;
    line-height: 24px;
  }
}
.zhuangtai-4-logo {
  position: absolute;
  z-index: 100;
  margin: 134px 0px 0px 1172px;
  width: 150px;
  height: 19px;
  span {
    position: relative;
    bottom: 3px;
    width: 54px;
    height: 15px;
    font-size: 16px;
   
    font-weight: 550;
    color: #44EA44;
    line-height: 24px;
  }
}
.logo {
  width: 21px;
  height: 19px;
}


.font {
    font-size: 100px;
}
//@import url(); 引入公共css类
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails/mod_screen_display_show/allDisplay.vue